<template>
    <div class="home-index">
        <div class="top-home">
            <div class="flex">
                <sideMenu :wareHouse="warehouseList" :doc="api" class="side-menu"></sideMenu>
                <banner class="top-left"></banner>
                <user-info :info="info" class="user-info"></user-info>
            </div>
        </div>
        <division title="热门工具" sub="Popular tools"></division>
        <middle-cate></middle-cate>
        <division title="电商工具" sub="Electricity tools"></division>
        <elTool></elTool>
        <division title="礼品发货" sub="Gift delivery"></division>
        <giftShop v-if="warehouseList.length > 0" :wareHouse="warehouseList"></giftShop>
        <!-- <division title="流量中心" sub="Traffic center"></division>
        <trafficCenter></trafficCenter> -->
        <division title="API开放平台" sub="API Open platform"></division>
        <apiSection :doc="api"></apiSection>
        <division title="最新资讯" sub="The latest consultation"></division>
        <news :tt="tt" :doc="api" :info="info"></news>
        <div v-if="+$store.state.configData.recharge_activity_status === 1">
            <new-bind-store v-if="newBindStoreDialog.show" v-model="newBindStoreDialog.show"
                :exData="newBindStoreDialog.exData"></new-bind-store>
        </div>
    </div>
</template>

<script>
import sideMenu from './sideMenu/index';
import banner from './banner/index';
import userInfo from './userinfo/index';
import division from './division/index';
import middleCate from './middleFeature/index';
import elTool from './elTool/index';
import giftShop from './giftShop/index';
import apiSection from './apiSection/index';
import news from './news/index';
import NewBindStore from '@/index/components/NewBindStore/index'

export default {
    components: {
        sideMenu,
        banner,
        userInfo,
        division,
        middleCate,
        elTool,
        giftShop,
        apiSection,
        news,
        NewBindStore
    },
    data() {
        return {
            tt: [],
            api: [],
            info: [],
            warehouseList: [],
            newBindStoreDialog: {
                show: false,
                exData: {}
            },
        }
    },
    methods: {
        async getDoc() {
            const data = await this.$fetch('/doc/apps/docs?type=1')
            if (data.code == 0) {
                this.api = data.data
            }
        },
        async getInfo() {
            const data = await this.$fetch('/tool/apps/get-article-list', { pageSize: 10 }, 'get')
            if (data.code == 0) {
                if (data.data.newest) {
                    this.tt = data.data.newest
                }
                if (data.data.recommended) {
                    this.info = data.data.recommended
                }
            }
        },
        async getWarehouse() {
            const data = await this.$fetch('/shop/webs/v1/get-warehouse-list', { page: 1, pageSize: 10 }, 'post')
            if (data.code == 0) {
                this.warehouseList = data.data
            }
        },
        openBindStore() {
            // if (this.isToolMainSite()) { // 必须是主站才能弹这个主站的活动弹框
            // }

            // 新的活动需要是 非接口用户 才弹出框
            if (this.$store.state.userData.show_active_api_json) {
                return false;
            }

            // 参与过活动且未超过30天的处理
            const hasHandle = () => {
                // 不弹框
            }

            // 未参与过活动或者参与过活动但是超过30天的处理
            const noHandle = () => {
                // noTips 表示不再弹出
                let noTips = localStorage.getItem("noTips")
                let noTipsTIme = localStorage.getItem("noTipsTIme")

                if (noTips && noTipsTIme) {
                    if ((new Date()).valueOf() > noTipsTIme) {
                        noTips = false; // 超过了 24 小时则表示可以弹出
                    }
                }

                if (!noTips) {
                    this.newBindStoreDialog.show = true;
                }
            }

            // 判断用户是否参与活动, 如果参与过活动, 则判断上次参与活动距离现在是否已经超过30天, 未超过30天则不弹框, 超过30天则判断本地限制弹框时间
            let vipActiveLastTime = this.$store.state.userData.vip_active_last_time;
            if (vipActiveLastTime) {
                if (((new Date()).valueOf() / 1000) > (vipActiveLastTime + 30 * 24 * 60 * 60)) {
                    // 超过 30 天
                    noHandle()
                } else {
                    // 未超过 30 天
                    hasHandle()
                }
            } else {
                noHandle()
            }
        }
    },
    mounted() {
        // this.$bus.on('openBindStore', () => this.openBindStore())
        // if (this.$store.state.userData.uid) {
        //     this.openBindStore()
        // }
        this.getInfo()
        this.getDoc()
        this.getWarehouse()
    },
}
</script>

<style lang="scss" scoped>
.home-index {
    padding-top: 20px;
    padding-bottom: 30px;
    padding-left: 0;
    text-align: left;
    width: 1200px !important;
    margin: 0 auto;
    left: 0;
}

.side-menu {
    flex-basis: 174px;
}

.top-home {
    height: 355px;

    // margin-left: 160px;
    .top-left {
        flex-basis: 718px;
    }

    .user-info {
        flex-basis: 280px;
        margin-left: 10px;
        box-shadow: 2px 2px 12px 2px rgb(0 0 0 / 10%);
    }

    .items {
        flex-basis: 648px;
    }

    .item {
        width: 212px;
        height: 151px;
        position: relative;
        cursor: pointer;
        border-right: 2px solid #f4f4f4;
        border-bottom: 2px solid #f4f4f4;
        box-sizing: border-box;

        img {
            margin-left: 6px;
            margin-top: 20px;
            /* max-width: 85px;
            max-height: 72px; */
        }
    }

    .settled {
        flex-basis: 300px;
    }
}
</style>
